import React, { useState, useEffect, useContext, useRef } from 'react'
import HeaderFilter from '../../components/subComponents/HeaderFilter'
import Stewardship from '../../components/subComponents/Stewardship'
import Status from '../../components/subComponents/Status'
import { GlobalContext } from '../../services/context'
import { Button } from 'syngenta-react-components'
import Select from '../../dpe-usco/components/Select/Select'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import DetailCardWithTable from '../../dpe-usco/components/Details/DetailCardWithTable'
import { getSalesYear } from '../../services/apiHelper'
import {
  convertToSentenceCase,
  convertToTitleCase,
  yearsOptionFactory
} from '../../services/utils'
import { useParams } from 'react-router-dom'
import { Table } from '../../dpe-usco'

const SELECT_CUSTOM_CLASS_NAMES = {
  buttonClassNames:
    'bgc-white bd2-s-input bdrs-4 h38 mt-1 df aic jcsb pl10 pt5 pb5 pr5'
}
const MAX_YEARS = 1 // max years to go above for years dropdown.
const MIN_YEARS = -4 // min years to go below for years dropdown. Example 2020 => 2019

const ContractTable = ({
  data,
  contractNavigates,
  showCreateContract,
  status,
  companyId,
  companyType,
  onScrollAPI,
  setSortOrder,
  setSortByKey,
  customSort,
  filterHandler,
  contractYear,
  displayCreatedDate,
  filterByStatus,
  setStatusArr,
  allYears,
  loadingData,
  setIsyearStatus,
  hideContractYear,
  statusDisable,
  isLoadExtraData,
  isReportPage
}) => {
  const { company_id } = useParams()
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const [tableData, setTableData] = useState()

  const [defaultContractYear, setDefaultContractYear] = useState(
    new Date().getFullYear().toString()
  )
  useEffect(() => {
    const init = async () => {
      await getSalesYear().then(sales_year => {
        setDefaultContractYear(sales_year.data.sales_year)
      })
    }
    if (contractYear) {
      init()
    }
  }, [contractYear])

  useEffect(() => {
    setTableData(data)
  }, [data])
  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setSortOrder('asc')
      setSortByKey(dataKey)
      setTableData(customSort(data, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setSortOrder('desc')
      setSortByKey(dataKey)
      setTableData(customSort(data, dataKey, 'desc'))
    }

    return (
      <div key={value} className="cell df aic">
        <span>{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }

  const yearsOptions = yearsOptionFactory(parseInt(defaultContractYear), MIN_YEARS, MAX_YEARS)

  const handleViewContract = (contractDetail,e) => {
    e.preventDefault()
    const payload = {
      company_id: company_id
        ? company_id
        : contractDetail.external_reference_id,
      detailView: {
        title: `${contractDetail.contract_year}: ${contractDetail.grower_name} to ${contractDetail.reseller}`,
        previous: 'Back',
        new_contract_id: contractDetail.new_contract_id
      },
      contract_id: contractDetail.contract_id
    }
    trackEvent('view_contract_clicked', {
      from: companyId ? 'contractDetailView' : 'contractDashboard',
      companyId: company_id,
      contractId: contractDetail.contract_id
    })
    dispatch({ type: 'GO_TO_CONTRACT', payload })
  }

  ///////////////////////////////////////////////////////////////////////////////////////
  const[isPendingChecked, setIsPendingChecked] = useState(true)
  const[isVoidedChecked, setIsVoidedChecked] = useState(isReportPage ? true : false)
  const[isCompletedChecked, setIsCompletedChecked] = useState(true)
  const[isPendingGrowerSigned, setIsPendingGrowerSigned] = useState(true)
  const[isAmendmentPendingGrower, setIsAmendmentPendingGrower] = useState(true)
  const[isAmendmentPending, setIsAmendmentPending] = useState(true)
  const[isAmendmentCompleted, setIsAmendmentCompleted] = useState(true)
  const [showDropdown, setShowDropdown] = useState(false)
  const findStatusArr = useRef(['pending', 'pendinggrowersigned', 'amendment_pending', 'amendmentpendinggrowersigned', 'completed', 'amendment_completed', ...(isReportPage ? ['voided'] : [])])

  const findStatusHandler = e => {
    const findStatus = e.target.value
    if(findStatus === 'pending'){
      if(!isPendingChecked){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else {
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsPendingChecked(prev => !prev)
    } else if(findStatus === 'voided'){
      if(!isVoidedChecked){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else{
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsVoidedChecked(prev => !prev)
    } else if(findStatus === 'completed'){
      if(!isCompletedChecked){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else{
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsCompletedChecked(prev => !prev)
    }
    else if(findStatus === 'amendment_pending'){
      if(!isAmendmentPending){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else{
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsAmendmentPending(prev => !prev)
    }
    else if(findStatus === 'amendmentpendinggrowersigned'){
      if(!isAmendmentPendingGrower){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else{
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsAmendmentPendingGrower(prev => !prev)
    }
    else if(findStatus === 'amendment_completed'){
      if(!isAmendmentCompleted){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else{
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsAmendmentCompleted(prev => !prev)
    }
    else if(findStatus === 'pendinggrowersigned'){
      if(!isPendingGrowerSigned){
        findStatusArr.current = [...findStatusArr.current, findStatus]
      } else{
        const index = findStatusArr.current.indexOf(findStatus)
        if (index > -1) {
          findStatusArr.current.splice(index, 1)
        }
      }
      setIsPendingGrowerSigned(prev => !prev)
    }
    setStatusArr([...findStatusArr.current])
    if(setIsyearStatus){
      setIsyearStatus(true)    
    }
  }

  const showDropdownFunc = () => {
    setShowDropdown(prev => !prev)
  }

  const statusHeading = {
    padding: 0, 
    margin: 0
  }

  const dropDownStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    width: '250px',
    marginTop: '5px',
    padding: '5px 0',
    fontWeight: '500',
    display: showDropdown ? 'block' : 'none',
    zIndex: 1
  }
  const statusInput = {
    display: 'inline-block',
    width: '13%',
    margin: 0
  }

  const statusContainer = {
    margin: '7px 0'
  }

  const arrowDown = {
    width: 0, 
    height: 0, 
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',    
    borderTop: '6px solid gray',
    position: 'absolute',
    margin: '7px 5px 5px 20px'
  }

  const node = useRef()
  const handleClick = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setShowDropdown(false)
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [])

  const dropDown = () => {
    return <div ref={node}>
      <p style={statusHeading}>
        Status {filterByStatus ? <span style={arrowDown} onClick={showDropdownFunc}></span> : null}
      </p>
      <div style={dropDownStyle}>
        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="pending"
            id="pending" 
            value="pending" 
            checked={isPendingChecked}
            disabled={statusDisable}
          />
          <label htmlFor="pending">
            Pending
          </label>
        </div>
        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="pendinggrowersigned"
            id="pendinggrowersigned" 
            value="pendinggrowersigned" 
            checked={isPendingGrowerSigned}
            disabled={statusDisable}
          />
          <label htmlFor="pendinggrowersigned">
            Pending Grower Signed
          </label>
        </div>
        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="amendment_pending"
            id="amendment_pending" 
            value="amendment_pending" 
            checked={isAmendmentPending}
            disabled={statusDisable}
          />
          <label htmlFor="amendment_pending">
             Amd Pending
          </label>
        </div>

        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="amendmentpendinggrowersigned"
            id="amendmentpendinggrowersigned" 
            value="amendmentpendinggrowersigned" 
            checked={isAmendmentPendingGrower}
            disabled={statusDisable}
          />
          <label htmlFor="amendmentpendinggrowersigned">
            Amd Pending Grower Signed
          </label>
        </div>

        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="completed"
            id="completed" 
            value="completed" 
            checked={isCompletedChecked}
            disabled={statusDisable}
          />
          <label htmlFor="completed">
            Completed
          </label>
        </div>
       
        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="amendment_completed"
            id="amendment_completed" 
            value="amendment_completed" 
            checked={isAmendmentCompleted}
            disabled={statusDisable}
          />
          <label htmlFor="amendment_completed">
            Amd Completed
          </label>
        </div>
       
        <div style={statusContainer}>
          <input
            style={statusInput}
            type="checkbox"
            onChange={findStatusHandler} 
            name="voided"
            id="voided" 
            value="voided" 
            checked={isVoidedChecked}
            disabled={statusDisable}
          />
          <label htmlFor="voided">
            Voided
          </label>
        </div>
       
      </div>
    </div>
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const structure = {
    headers: [
      displayCreatedDate ? {
        value: 'Created Date',
        format() {
          return headerCell(this.value, 'created_date')
        }
      } : {
        value: 'Year',
        format() {
          return headerCell(this.value, 'contract_year')
        }
      },
      {
        value: 'Contract ID',
        format() {
          return headerCell(this.value, 'new_contract_id')
        }
      },
      {
        value: 'Grower',
        format() {
          return headerCell(this.value, 'grower_name')
        }
      },
      {
        value: 'Reseller',
        format() {
          return headerCell(this.value, 'reseller')
        }
      },
      {
        value: 'Contract type',
        format() {
          return headerCell(this.value, 'contract_type')
        }
      },
      {
        value: dropDown(),
        format() {
          return headerCell(this.value, 'contract_status')
        }
      },
      
      isReportPage ? 
        {
          value: 'Program Name',
          format() {
            return headerCell(this.value, 'program_name')
          }
        } : {
          value: '',
          format() {
            return <div key="space" className="w150" />
          }
        }
    ],
    dataKeys: [
      displayCreatedDate ? 'created_date':'contract_year',
      'new_contract_id',
      'grower_name',
      'reseller',
      'contract_type',
      'contract_status',
      isReportPage ? 'program_name' : 'contract_id'
    ],
    rowFormat: {
      contract_year: {
        format: contract => {
          return contractNavigates ? <span>{contract}</span> : contract
        }
      },
      contract_status: {
        customStyle: 'p0',
        format: status => {
          let color = 'green'
          if (status === 'pending') {
            color = 'yellow'
          } else if (status === 'Denied' || status === 'voided') {
            color = 'red'
          } else if(status === 'amendment_pending'){
            color = 'yellow'
            status = 'amendment pending'
          } else if(status === 'amendment_completed'){
            status = 'amendment completed'
          }  else if(status === 'amendmentpendinggrowersigned'){
            color = 'yellow'
            status = 'amd pend grower signed'
          } else if(status === 'pendinggrowersigned'){
            color = 'yellow'
            status = 'pending grower signed'
          }
          
          return <Status color={color} status={status} />
        }
      },
      stewardship: {
        format: stewardship => {
          return <Stewardship count={stewardship} />
        }
      },
      contract_type: {
        format: type => {
          return convertToSentenceCase(type)
        }
      },
      program_name: {
        customStyle: '',
        format: name => {
          return <div className='ml16'>{convertToSentenceCase(name)}</div>
        }
      },
      reseller: {
        format: reseller => {
          return convertToTitleCase(reseller)
        }
      },
      contract_id: {
        customStyle: 'w130',
        overwriteStyles: true,
        allContent: true,
        format: contractDetails => {
          return (
            <div data-testid="viewContractButton">
              <a href={`/company/${company_id?company_id:contractDetails.external_reference_id}/contracts/${contractDetails.contract_id}`} onClick={e => handleViewContract(contractDetails,e)}>
                <Button styleType="success" customClassName="">
                  View
                </Button>
              </a>
            </div>
          )
        }
      }
    }
  }
  if(hideContractYear) {
    structure.headers.shift()
    structure.dataKeys.shift()
    Reflect.deleteProperty(structure.rowFormat, structure.rowFormat.contract_year)
  }

  let queryParams = ''
  if (companyType && companyId)
    switch (companyType) {
      case 'grain-receiver':
        queryParams = `grain_receiver_id=${companyId}`
        break
      case 'reseller':
        queryParams = `reseller_id=${companyId}`
        break
      case '3PO':
        queryParams = `3PO_id=${companyId}`
        break
      default:
        break
    }

  const createNewContract = () => {
    trackEvent('create_contract_clicked', {
      from: 'companyDetailView',
      companyId
    })
    dispatch({ type: 'GO_TO_CREATE_CONTRACT', payload: { queryParams } })
  }

  const renderButtonRow = (
    <div className="df w300 jcsb">
      <div>
        {showCreateContract ? (
          <Button
            type="success"
            text="Create contract"
            clickHandler={createNewContract}
          />
        ) : null}
      </div>
      <div style={{ width: '130px', pointerEvents: loadingData ? 'none' : 'auto' }} className="w100">
        <Select
          customClassName={SELECT_CUSTOM_CLASS_NAMES}
          handleSelection={year => {
            filterHandler(year.value)
          }}
          defaultValue={contractYear ? contractYear : 'Select Year'}
          options={allYears ? allYears : yearsOptions}
        />
      </div>
    </div>
  )


  return (
    <div data-testid="contractTable">
      {
        isReportPage ? 
          <Table
            structure={structure}
            data={data}
            isLoadExtraData={isLoadExtraData}
            onScrollAPI={onScrollAPI}
            statusComponent={
              status ? (
                <TableStatus
                  status={status}
                  prompt={
                    company_id ? 'No contracts for this sales year' : 'No data'
                  }
                />
              ) : null 
            }
            
          />
          : <DetailCardWithTable
            button={!isReportPage && renderButtonRow}
            title="Contracts"
            structure={structure}
            data={tableData}
            isLoadExtraData={isLoadExtraData}
            isReportPage={isReportPage}
            statusComponent={
              status ? (
                <TableStatus
                  status={status}
                  prompt={
                    company_id ? 'No contracts for this sales year' : 'No data'
                  }
                />
              ) : null 
            }
            onScrollAPI={onScrollAPI}
          />
      }
    </div>
  )
}

export default ContractTable
